import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DefaultSingleWaveDrop } from "./DefaultSingleWaveDrop";
import { MemesSingleWaveDrop } from "./MemesSingleWaveDrop";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
interface SingleWaveDropProps {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
export enum SingleWaveDropTab {
  INFO = "INFO",
  CHAT = "CHAT",
}
export const SingleWaveDrop: React.FC<SingleWaveDropProps> = t0 => {
  const $ = _c(6);
  const {
    drop: initialDrop,
    onClose
  } = t0;
  const {
    isMemesWave
  } = useSeizeSettings();
  const isMemes = isMemesWave(initialDrop.wave.id);
  if (isMemes) {
    let t1;
    if ($[0] !== initialDrop || $[1] !== onClose) {
      t1 = <MemesSingleWaveDrop drop={initialDrop} onClose={onClose} />;
      $[0] = initialDrop;
      $[1] = onClose;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== initialDrop || $[4] !== onClose) {
    t1 = <DefaultSingleWaveDrop drop={initialDrop} onClose={onClose} />;
    $[3] = initialDrop;
    $[4] = onClose;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};